import general from './components/general.js';
import alerts from './components/alerts.js';
import calcChildSize from './components/calcChildSize.js';
import readMore from './components/readMore.js';
import imgSlider from './components/imgSlider.js';
import shareUrl from './components/shareUrl.js';
import videoEmbed from './components/videoEmbed.js';
import scrollTo from './components/scrollTo.js';
import printWindow from './components/printWindow.js';
import easyDrop from './components/easyDrop.js';
import countdown from './components/countdown.js';
import { polyfill } from "seamless-scroll-polyfill";

document.addEventListener('DOMContentLoaded', () => {
    polyfill();
    general.init();
    alerts.init();
    scrollTo.init();
    readMore.init();
    countdown.init();
    imgSlider.init();
    printWindow.init();
    shareUrl.init();
    calcChildSize.init();
    easyDrop.init();
    videoEmbed.init();
});